import { useEffect } from "react";

const SITE_URL = "https://www.actipace.com";

function Seo({ title, description, path }) {
    useEffect(() => {
        document.title = title;
        let descriptionTag = document.querySelector('meta[name="description"]');
        if (!descriptionTag) {
            descriptionTag = document.createElement("meta");
            descriptionTag.setAttribute("name", "description");
            document.head.appendChild(descriptionTag);
        }
        descriptionTag.setAttribute("content", description);
        let canonicalTag = document.querySelector('link[rel="canonical"]');
        if (!canonicalTag) {
            canonicalTag = document.createElement("link");
            canonicalTag.setAttribute("rel", "canonical");
            document.head.appendChild(canonicalTag);
        }
        canonicalTag.setAttribute("href", `${SITE_URL}${path}`);
        return () => { document.title = "Actipace"; };
    }, [description, path, title]);
    return null;
}

export default Seo;
